import React from 'react';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import { Field, Form, reduxForm } from 'redux-form';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { cloneDeep } from 'lodash';

import FieldWrapper from 'components/common/FieldWrapper';
import CategoryCheckboxes from './CategoryCheckboxes';
import { secondPageValidations } from './validations';
import { categoryOptions } from './utils';

export function SecondPage({
  categoryGroups,
  error,
  handleSubmit,
  myArrayInsert,
  myArrayRemove,
  previousPage,
  selectCategory,
  selectedCategory
}) {
  const COLUMN_COUNT_FOR_XS = 2;
  const COLUMN_COUNT_FOR_SM = 3;
  const COLUMN_COUNT_FOR_MD = 4;
  const disabled = Boolean(error);

  const inGroupsOf = (items, colCount) =>
    items.reduce((groups, currentValue, index) => {
      const clonedGroup = cloneDeep(groups);
      const columnCapacity = Math.ceil(items.length / colCount);
      const groupIndex = Math.floor(index / columnCapacity);

      if (!clonedGroup[groupIndex]) clonedGroup[groupIndex] = [];

      clonedGroup[groupIndex].push(currentValue);

      return clonedGroup;
    }, []);

  const columnCount = () => {
    if (!window.matchMedia) return COLUMN_COUNT_FOR_MD;
    if (window.matchMedia('(min-width: 992px)').matches) {
      return COLUMN_COUNT_FOR_MD;
    }
    if (window.matchMedia('(min-width: 768px)').matches) {
      return COLUMN_COUNT_FOR_SM;
    }
    return COLUMN_COUNT_FOR_XS;
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <h2 id="partner-contact-form-heading">
            Affiliate/Publisher Interest Questionnaire
            <br />
            <small className="smaller block">
              In which verticals do you currently generate calls (check all that
              apply)?
            </small>
          </h2>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col xs={12}>
          <ButtonGroup className="pull-right">
            <Button bsStyle="warning" onClick={previousPage}>
              <FontAwesome name="chevron-left" tag="i" />
              {' Back'}
            </Button>
            <Button bsStyle="success" disabled={disabled} type="submit">
              {'Next '}
              <FontAwesome name="chevron-right" tag="i" />
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      {categoryGroups.map((group) => (
        <div key={group.name}>
          <h5 className="margin-bottomgap20">{group.name}</h5>
          <Row>
            {inGroupsOf(group.categoryOptions, columnCount()).map((options) => (
              <Col key={options[0].value} xs={6} sm={4} md={3}>
                <Field
                  categoryOptions={categoryOptions}
                  arrayInsert={myArrayInsert}
                  arrayRemove={myArrayRemove}
                  component={CategoryCheckboxes}
                  categoryOptionsForGroup={options}
                  name="category_ids"
                  selectCategory={selectCategory}
                  selectedCategory={selectedCategory}
                />
              </Col>
            ))}
          </Row>
          <br />
        </div>
      ))}
      <Row>
        <Col xs={12} smOffset={4} sm={4}>
          <Field
            component={FieldWrapper}
            inputComponent="textarea"
            inputComponentProps={{
              className: 'form-control',
              rows: 3
            }}
            label="Add any verticals not listed above"
            name="additional_information"
            showLabel
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="margin-bottomgap20">
          <ButtonGroup className="pull-right">
            <Button bsStyle="warning" onClick={previousPage}>
              <FontAwesome name="chevron-left" tag="i" />
              {' Back'}
            </Button>
            <Button bsStyle="success" disabled={disabled} type="submit">
              {'Continue '}
              <FontAwesome name="chevron-right" tag="i" />
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Form>
  );
}

SecondPage.propTypes = {
  categoryGroups: arrayOf(shape({})).isRequired,
  error: oneOfType([arrayOf(string), string]),
  handleSubmit: func.isRequired,
  myArrayInsert: func.isRequired,
  myArrayRemove: func.isRequired,
  previousPage: func.isRequired,
  selectCategory: func.isRequired,
  selectedCategory: shape({
    label: string,
    value: number
  }).isRequired
};

SecondPage.defaultProps = {
  error: ''
};

export default reduxForm({
  form: 'partnerSubmissionForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: secondPageValidations
})(SecondPage);
